// material-ui
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';

// project imports
import { DRAWER_WIDTH, CHAT_DRAWER_WIDTH } from 'config';

const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'chatOpen'
})(({ theme, open, chatOpen }) => {
  const chatOffset = chatOpen ? CHAT_DRAWER_WIDTH : 0;
  const transition = theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  });

  if (open) {
    return {
      zIndex: theme.zIndex.drawer + 1,
      marginLeft: DRAWER_WIDTH,
      width: `calc(100% - ${DRAWER_WIDTH}px - ${chatOffset}px)`,
      transition
    };
  }

  return {
    zIndex: theme.zIndex.drawer + 1,
    width: `calc(100% - ${theme.spacing(7.5)} - ${chatOffset}px)`,
    transition
  };
});

export default AppBarStyled;
